import {Button} from "../../../../../components/general/input/Button";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import {paymentValidator} from "../../../../../components/payment/paymentValidator";
import useSession from "../../../../services/state/session/useSession";
import {useDispatch, useSelector} from "react-redux";
import {runInitialPaymentStep} from "../../../../../components/payment/PaymentProcessor";
import useValueChangeListener from "../../../../services/state/general/useValueChangeListener";
import {useShallow} from "zustand/react/shallow";

const addInputBlockers = (blockers, input) => {
    if(!(input.locationID > 0))
        blockers.push("Please select a delivery location")
    else if(!input.deliveryMethod)
        blockers.push('Please select a delivery method')
    else if(!input.deliveryDate)
        blockers.push("Please select a delivery date")
    else if(!input.paymentRule)
        blockers.push("Please select a payment type")
    else if(input.paymentRule === 'K') {
        const card = input.card;
        if(!card) {
            blockers.push("Please select a stored card, or enter a new one.")
        } else if((card.bankID ?? 0) <= 0) {
            if(!card.firstName || !card.lastName) {
                blockers.push("Full name on card is missing");
            } else if(paymentValidator.validateCardNumber(card.cardNumber)) {
                blockers.push("Card number is not valid");
            } else if(paymentValidator.validateExpiry(card.expireMonth + "/" + card.expireYear)) {
                blockers.push("Card expiry is not valid");
            } else if(paymentValidator.validateCvv(card.cvv)) {
                blockers.push("Card cvv not valid");
            }
        }
    }
}

const getCardPaymentInfo = (session, cardInput, amount, overPayment, charge_amount, locationID, orderID) => {
    return {
        ...cardInput,
        currency: 'GBP',
        overPayment,
        amount: amount.toFixed(2),
        locationID: locationID,
        bPartnerID: session.bPartnerID,
        userID: session.userID,
        orderID: orderID,
        surcharge: charge_amount
    };
}

const CartCheckoutButton = () => {

    const dispatch = useDispatch();
    const session = useSession();
    const blockers = [];
    const {
        orderID, locationID, input, prepareIt,
        completeIt, due, overPayment
    } = useCheckoutStore(
        useShallow((state) => ({
            orderID: state.orderID,
            locationID: state.order?.C_BPartner_Location_ID?.id,
            input: state.input,
            prepareIt: state.prepareIt,
            completeIt: state.completeIt,
            due: state.getTotalDue(),
            overPayment: state.paymentDetails?.overPayment,
        }))
    );

    const { paymentResult } = useSelector(
        state => state.session.payment
    );
    useValueChangeListener(async () => {
        if(paymentResult && paymentResult.success) {
            completeIt(session);
        }
    }, [paymentResult]);

    addInputBlockers(blockers, input);
    const canCheckout = blockers.length === 0;

    const onClick = () => {
        if(canCheckout) {
            if(input.paymentRule === 'K') {
                const takePayment = () => runInitialPaymentStep(dispatch, session.sessionData, getCardPaymentInfo(
                    session.sessionData, input.card, due, overPayment ?? 0,
                    0, locationID, orderID
                ))
                prepareIt(session, takePayment);
            } else {
                prepareIt(session, () => completeIt(session));
            }
        }
    }

    return  (
        <>
            {blockers.map((e,i) =>
                <p key={i} className="cart-blocker">{e}</p>
            )}
            <Button
                onClick={onClick}
                className={ canCheckout ? "" : "inactive" }
            >
                Checkout
            </Button>
        </>
    )
}

export default CartCheckoutButton;
